const camelToSnakeCase = (str) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export const mutationNamer = (propName) => `SET_${camelToSnakeCase(propName).toUpperCase()}`;

export const gettersNamer = (propName) => `get${capitalizeFirstLetter(propName)}`;

export const actionNamer = (propName) => `set${capitalizeFirstLetter(propName)}`;
